module.exports = __webpack_public_path__ + "img/DSC_0104.efb32c0e.jpg";